export function initRevealAnimations({ gsap, ScrollTrigger, reducedMotion }) {
    const elements = gsap.utils.toArray('[data-reveal]').filter((element) => !element.closest('[data-studio-page]'));

    if (!elements.length || reducedMotion) {
        gsap.set(elements, { clearProps: 'all' });
        return;
    }

    const context = gsap.context(() => {
        elements.forEach((element) => {
            gsap.fromTo(
                element,
                { autoAlpha: 0, y: 40 },
                {
                    autoAlpha: 1,
                    y: 0,
                    duration: 1,
                    ease: 'power3.out',
                    scrollTrigger: {
                        trigger: element,
                        start: 'top 88%',
                        once: true,
                    },
                },
            );
        });
    });

    window.addEventListener('pagehide', () => context.revert(), { once: true });
}
